import { FormValue } from '@components/modals/add-holder-modal/src/add-holder-modal.type';
import { useGenericMutation } from '@hooks/use-generic-mutation';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';
import { requestDownloadWithFilename } from '@utils/request/request-download';

import { QUERY_KEYS } from './constants';
export type FileType = 'pdf';
export type Base64<filetype extends FileType> = `data:application/${filetype};base64${string},`;
export interface BoxOfficeResponse {
  file: Base64<'pdf'>;
  id: string;
  legacyId: number;
}
const createBoxOffice = ({ formValue, isWebView }: { formValue: FormValue; isWebView?: boolean }) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/box-office`;
  if (isWebView) {
    return requestDownloadWithFilename({ url, method: RequestMethod.POST, body: formValue });
  }
  return request({ url, method: RequestMethod.POST, body: formValue });
};

export const useCreateBoxOffice = () => {
  return useGenericMutation<
    BoxOfficeResponse & { blob: Blob; filename?: string } & Blob,
    RequestError,
    { formValue: FormValue; isWebView?: boolean }
  >([QUERY_KEYS.createBoxOffice], async ({ formValue, isWebView }: { formValue: FormValue; isWebView?: boolean }) =>
    createBoxOffice({ formValue, isWebView })
  );
};
